<div
  class="em-c-hero supplier-api-home hero-background"
  style="background-image: url(assets/images/hero-block.jpg)"
>
  <div class="em-c-hero__body">
    <div class="em-l-container">
      <h1 class="em-c-hero__title title-text">Chemical IT - Supplier API</h1>
      <p class="em-c-hero__desc">
        Welcome, {{ (storeService.user$ | async)?.name }}
      </p>
    </div>
  </div>
</div>
<!-- end em-c-tooltip -->
<div class="em-l-container section">
  <div class="em-l-grid em-l-grid--2up">
    <div class="em-l-grid__item home-page-icon-container">
      <img
        src="assets/images/purchasing-demand-icon.png"
        class="home-page-icon"
      />
    </div>
    <div class="em-l-grid__item home-page-desc-container">
      <h2 class="item-title">Purchasing Demand API</h2>
      <p class="item-detail">
        Collaboration with raw materials suppliers, allowing them to better plan
        for the manufacture and supply of raw materials for EMCC's consumption.
        Purchasing Demand API providing suppliers with purchasing demand
        requirements (i.e. PR and PO published from MRP runs) in a secure,
        scalable, sustainable, efficient, and reliable manner.
      </p>
      <button
        class="em-c-btn em-c-btn--primary cta-button"
        [routerLink]="['/api-document']"
      >
        <span class="em-c-btn__text">API Spec</span>
      </button>
    </div>
  </div>
</div>

<div class="alt-section">
  <div class="em-l-container section">
    <div class="em-l-grid em-l-grid--2up">
      <div class="em-l-grid__item home-page-desc-container">
        <h2 class="item-title">Supplier Profile</h2>
        <p class="item-detail">
          The Supplier Profile serves to define exceptions arising from
          different suppliers' requirements. Essentially, these exceptions
          influence the Purchasing Demand Application's data formatting and data
          filtering criteria.
        </p>
        <button
          class="em-c-btn em-c-btn--primary cta-button"
          [routerLink]="['supplier-profile']"
        >
          <span class="em-c-btn__text">Explore</span>
        </button>
      </div>
      <div class="em-l-grid__item home-page-icon-container">
        <img
          src="assets/images/supplier-profile-icon.png"
          class="home-page-icon"
        />
      </div>
    </div>
  </div>
</div>

<div class="em-l-container section">
  <div class="em-l-grid em-l-grid--2up">
    <div class="em-l-grid__item home-page-icon-container">
      <img
        src="assets/images/notification-engine-icon.png"
        class="home-page-icon"
      />
    </div>
    <div class="em-l-grid__item home-page-desc-container">
      <h2 class="item-title">Notification Engine</h2>
      <p class="item-detail">
        Notification Engine notifies EMCC RMCs via email whenever their raw
        material requirements are published to IDP and whenever the suppliers
        ingest the corresponding plans. One stop self-service to
        subscribe/unsubscribe notification and maintain notification template.
      </p>
      <button
        class="em-c-btn em-c-btn--primary cta-button"
        [routerLink]="['notification-engine']"
      >
        <span class="em-c-btn__text">Explore</span>
      </button>
    </div>
  </div>
</div>
